import React, { useState, useRef, useEffect } from 'react';
import { Modal, Form, Button, InputNumber, message, Typography } from 'antd';
import { useParams } from 'react-router';
import API from '../../../../services/API';

const { Link } = Typography;

export default function SSNMatch() {
  
  const formRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);

  let { userId } = useParams();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const matchSSN = (data) => {
    console.log('void transactions', data);
    showModalLoading(true);
    API.matchUserSSN({ userId, ssn: data.ssn }).then((resp) => {
      console.log('resp', resp);
      showModalLoading(false);
      message.success("Successfully matched SSN");
    }).catch((error) => {
      console.log('error', error);
      showModalLoading(false);
      message.error("SSN did not match.");
    });
  };

  const cancelVoid = () => {
    formRef.current?.resetFields();
    setIsModalOpen(false);
  };

  const onFinish = (data) => {
    console.log('data', data);
    matchSSN(data);
  };

  useEffect(() => {

  }, []);

  const onFinishFailed = (error) => {
    console.log('new error', { ... error});
  };

  return (
    <>
      <Link onClick={showModal}>
      <small>(Match)</small>
      </Link>
      <Modal title={"Dispute Transactions"} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          ref={formRef}
        >
          <Form.Item label="SSN" name="ssn" rules={[{ required: true, message: 'Please enter a SSN' }]}>
            <InputNumber />
          </Form.Item>
          <div>
            <Form.Item >
              <Button type="primary" htmlType="submit" disabled={modalLoading}>
                Submit
              </Button>
              &nbsp;
              <Button htmlType="button" onClick={cancelVoid} disabled={modalLoading}>
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
}